import { createFileRoute, Outlet } from '@tanstack/react-router';

import { SourcingScenarioTabs } from '@/areas/sourcing-scenarios/SourcingScenarios/components/SourcingScenarioTabs';
import type { PageStaticData } from '@/shared/routing';

// A scenario's pages below its tab row. Today's tree has no such layout: its Sourcing sidebar lists the scenario's pages.
export const Route = createFileRoute('/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId')(
    {
        // Each page checks who may open it.
        staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
        component: RouteComponent,
    },
);

function RouteComponent(): JSX.Element {
    const { projectId, sourcingScenarioId } = Route.useParams();
    return (
        <SourcingScenarioTabs projectId={projectId} sourcingScenarioId={sourcingScenarioId}>
            <Outlet />
        </SourcingScenarioTabs>
    );
}
